<template>
    <v-col class="pa-0 ma-0">
        <highcharts :constructor-type="'stockChart'" :options="tempChartOption"></highcharts>
        <v-chip class="ml-3" outlined color="primary">
            <v-btn x-small fab text @click="selectedDate = $moment(selectedDate).subtract(1, 'days')">
                <v-icon>
                    mdi-chevron-left
                </v-icon>
            </v-btn>
            {{ $moment(selectedDate).format('ddd DD MMM') }}
            <v-btn x-small fab text @click="selectedDate = $moment(selectedDate).add(1, 'days')">
                <v-icon>
                    mdi-chevron-right
                </v-icon>
            </v-btn>
        </v-chip>
    </v-col>
</template>

<script>
// import highchart theme
export default {
    name: 'WeatherChart',
    props: {
        param: {
            type: String,
            default: 'temperature_2m'
        },
        unit: {
            type: String,
            default: '°C'
        },
        biomass: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: 'line'
        }
    },
    computed: {
        tempChartOption() {
            var self = this
            return {
                series: [{
                    type: this.biomass ? 'column' : this.type,
                    data: this.weatherData
                }],
                chart: {
                    height: '250px',
                },
                scrollbar: {
                    enabled: false
                },
                // header
                title: {
                    enabled: false
                },
                // control butto
                rangeSelector: {
                    enabled: false
                },
                // navigation 
                navigator: {
                    enabled: false
                },
                xAxis: {
                    type: 'datetime',
                    labels: {
                        enabled: true,
                        useHTML: true,
                        formatter: function () {
                            return `<div style="color:white">${self.$moment(this.value).format('HH:mm')}</div>`
                        }
                    },
                    plotLines: [{
                        color: '#F4A900', // Red
                        width: 2,
                        text: 'Now',
                        value: new Date().getTime() // Position, you'll have to translate this to the values on your x axis
                    }],
                },
                yAxis: {
                    // plotBands: [{
                    //     color: 'rgba(255, 0, 0, .1)', // Color value
                    //     from: 0, // Start of the plot band
                    //     to: 10 // End of the plot band
                    // }],
                    // plotLines: [{
                    //     color: 'red',
                    //     dashStyle: 'dash',
                    //     width: 2,
                    //     value: 10 // Position, you'll have to translate this to the values on your x axis
                    // }],
                },
                plotOptions: {
                    dataGrouping: {
                        enabled: true
                    },
                    line: {
                        dataLabels: {
                            enabled: true,
                            useHTML: true,
                            y: 15,
                            formatter: function () {
                                if (self.unit == 'km/h' || self.unit == 'mm/h') {
                                    return `<div style="text-align:center;">${Math.round(this.y)}<br/>${self.unit}</div>`
                                } else {
                                    return `<div style="border:1px solid black;color:black;width:25px;font-size:.8em;height:25px;background-color:#F4A900;border-radius:20px;text-align:center;padding-top:6px;">${Math.round(this.y)}${self.unit}</div>`
                                }
                            }
                        }
                    },
                    column: {
                        dataLabels: {
                            enabled: true,
                            useHTML: true,
                            y: 15,
                            formatter: function () {
                                if (self.unit == 'km/h' || self.unit == '%' || self.unit == 'mm/h') {
                                    return `<div style="text-align:center;">${Math.round(this.y * 100) / 100}<br/>${self.unit}</div>`
                                } else {
                                    return `<div style="border:1px solid black;color:black;width:25px;font-size:.8em;height:25px;background-color:#F4A900;border-radius:20px;text-align:center;padding-top:6px;">${Math.round(this.y)}${self.unit}</div>`
                                }
                            }
                        }
                    },
                    series: {
                        lineWidth: 5,
                        dataGrouping: {
                            enabled: true,
                        }
                    }
                }
            }
        }
    },
    data: () => ({
        pictoChartOptions: {},
        selectedDate: new Date(),
        weatherData: [],

    }),
    methods: {
        getData() {
            let url = this.biomass ?
                `https://api.ambeedata.com/ndvi/latest/by-lat-lng?lat=48.85&lng=2.35` :
                `https://api.open-meteo.com/v1/forecast?latitude=48.85&longitude=2.35&hourly=${this.param}&start_date=${this.$moment(this.selectedDate).format('YYYY-MM-DD')}&end_date=${this.$moment(this.selectedDate).format('YYYY-MM-DD')}`
            //&forecast_days=1
            let headers = {};

            if (this.biomass) {
                headers = {
                    'x-api-key': '5c9b68ca285cf1b723b7e1334608cf6957b1869d169237080a98b6bbeec51d6d'
                }
            }
            this.$axios.get(url, { headers: headers }).then(res => {
                let nbDay = this.biomass ? res.data.data.length : res.data.hourly.time.length
                this.weatherData = []
                // console.log('res', res)
                for (var i = 0; i < nbDay; i++) {
                    // send last data
                    this.$emit('lastData', this.biomass ? res.data.data[i].ndvi * 100 : res.data.hourly[this.param][i])
                    !this.biomass ?
                        this.weatherData.push([this.$moment(res.data.hourly.time[i]).unix() * 1000, res.data.hourly[this.param][i]])
                        : this.weatherData.push([
                            this.$moment(res.data.data[i].createdAt).unix() * 1000,
                            res.data.data[i].ndvi * 100
                        ])
                }
            })
        }
    },
    mounted() {
        this.getData()
    },
    watch: {
        selectedDate() {
            this.getData()
        }
    }
};
</script>